export abstract class BannerHelper {
	private static readonly storageKey = "bts_banner";
	private static readonly showingCount = 3;

	public static clearNotification(isOpen: boolean) {
		if (isOpen) {
			this.setNewCounter(0);
		}
	}

	public static getIsNotificationVisibleFromStorage() {
		return this.getCloseBannerCounter() < this.showingCount;
	}

	public static closeNotification() {
		const counter = this.getCloseBannerCounter();
		this.setNewCounter(counter + 1);
	}

	public static getCloseBannerCounter(): number {
		const value = JSON.parse(sessionStorage.getItem(this.storageKey) || "0") as string;
		return Number(value) || 0;
	}

	private static setNewCounter(value: number) {
		sessionStorage.setItem(this.storageKey, String(value || 0));
	}
}
